import * as React from 'react';
import { createContext, useContext } from 'react';

/**
 * These are the contexts that this application can be in.
 *
 * Socrative: launched through b.socrative.com
 * ShowbieAssessments:
 * Integration: The teacher is using the integration activity type.
 */
export enum StudentApplicationContext {
  /** Launched through b.socrative.com */
  Socrative = 'socrative',
  /** Launched inside of the showbie application (web or ios) */
  ShowbieAssessments = 'showbie_assessments',
}

export const StudentApplicationContextContext = createContext<
  StudentApplicationContext | undefined
>(undefined);

interface StudentApplicationContextProviderProps {
  children: React.ReactNode;
  applicationContext: StudentApplicationContext;
}

/**
 * Provides a way for application to be aware of the context it is in.
 */
export const StudentApplicationContextProvider = ({
  children,
  applicationContext,
}: StudentApplicationContextProviderProps) => {
  return (
    <StudentApplicationContextContext.Provider value={applicationContext}>
      {children}
    </StudentApplicationContextContext.Provider>
  );
};

export function useStudentApplicationContext() {
  const applicationContext = useContext(StudentApplicationContextContext);
  if (applicationContext === undefined) {
    throw new Error('StudentApplicationContextContext not found');
  }
  return applicationContext;
}
